export default __webpack_public_path__ + "static/media/track-mounted.3c17a699.svg";